export default "__VITE_ASSET__CsvbZh3E__"